import { Component, OnInit, Input } from '@angular/core';
import { ImagePipe } from '../../shared/image.pipe';
import { Ondemand } from '../../shared/interfacce.model';
import { BehaviorSubject, combineLatest, map, startWith } from 'rxjs';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-video-thumbnail',
  templateUrl: './video-thumbnail.component.html',
  styleUrls: ['./video-thumbnail.component.css'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate(500, style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate(500, style({ opacity: 0 }))
      ])
    ])
  ]
})
export class VideoThumbnailComponent implements OnInit {

  constructor(private imagePipe: ImagePipe) {}

  @Input() ondemand!: Ondemand;
  
  placeholderUrl = '';
  isImageLoaded = new BehaviorSubject<boolean>(false);
  isGifLoaded = new BehaviorSubject<boolean>(false);

  imageLoaded = this.isImageLoaded.asObservable();
  backgroundImage = combineLatest([this.imageLoaded.pipe(startWith(false))]).pipe(map(([isLoaded]) => `url('${isLoaded ? this.getCopertina(this.ondemand) : this.placeholderUrl}'), url(../../../assets/images/default_copertina.png)`));

  gifLoaded = this.isImageLoaded.asObservable();
  backgroundGif = combineLatest([this.gifLoaded.pipe(startWith(false))]).pipe(map(([isLoaded]) => `url('${isLoaded ? this.ondemand.cloudflare_preview_url : this.placeholderUrl}')`));  

  ngOnInit(): void {
    this.preloadImage();
  }

  getCopertina(ondemand: Ondemand) {
    return ondemand.copertina ? this.imagePipe.transform(ondemand.copertina) : ondemand.cloudflare_image_url
  }

  getTime(sec: number) {
    return Math.floor(sec / 60) <= 0 ? sec + " sec" : Math.floor(sec / 60) + " min";
  }

  preloadImage() {
    const img = new Image();
    img.onload = () => this.isImageLoaded.next(true);
    img.src = (this.getCopertina(this.ondemand) || '').toString();
    img.onerror = () => {
      img.src = '../../../assets/images/default_copertina.png';
    }
  }

}